<template>
    <header
        v-if="title || viewOrderUrl"
        class="align-center flex justify-between"
    >
        <h1
            v-if="title"
            class="text-heading-md font-bold text-content-primary"
        >
            {{ title }}
        </h1>
        <DsButton
            v-if="viewOrderUrl"
            :href="viewOrderUrl"
            size="sm"
            variant="tertiary"
        >
            View this file in Closinglock
        </DsButton>
    </header>
</template>

<script setup lang="ts">
import DsButton from '@/components/design-system/button/DsButton.vue';

defineProps<{
    viewOrderUrl?: string | null;
    title?: string;
}>();
</script>
